import * as React from "react"
import * as styles from "./styles.module.scss"
import ArticleTile from "components/Blog/ArticleTile"

export interface ReadNextProps {
  children: React.ReactNode
  posts: Post[]
}

export interface Post {
  slug: string
  imageSrc: string
  title: string
  excerpt: string
}

const ReadNext: React.FC<ReadNextProps> = ({ children, posts = [] }) => {
  return (
    <>
      {/* // {{#get "posts" limit="3" filter="tags:{{primary_tag.slug}}+id:-{{id}}"}} */}
      {posts && (
        <aside className={styles.readNext}>
          <div className={styles.pagePadding}>
            <header className={styles.header}>
              <h2 className={styles.heading}>Understand more, worry less</h2>
            </header>
            <ul className={styles.list}>
              {posts.map((post) => {
                const { slug, imageSrc, title, excerpt } = post
                return (
                  <li className={styles.item} key={slug}>
                    <ArticleTile
                      slug={`/content${slug}`}
                      imageSrc={imageSrc}
                      imageAlt={``}
                      title={title}
                      excerpt={excerpt}
                    />
                  </li>
                )
              })}
            </ul>
          </div>
        </aside>
      )}
    </>
  )
}

export default ReadNext
